import axios from '@api'

export default {
  getDoaApproval () {
    return axios.get(`api/management/doaapproval/`)
  },
  getDoaApprovalById (id) {
    return axios.get(`api/management/doaapproval/id/${id}`)
  },
  saveDoaApprovalById (json) {
    return axios.patch(`api/management/doaapproval/save/`, json)
  },
  deleteDoaById (id) {
    return axios.delete(`api/management/doaapproval/delete/${id}`)
  }
}